<template>
  <div class="profile">
    <div class="fl">
      <Menu :active-name="activeKey">
        <Menu-group title="主营业务">
          <Menu-item
            v-for="item   in companyList"
            :key="item.id"
            :to="item.route"
            :name="item.id"
          >{{item.name}}</Menu-item>
        </Menu-group>
      </Menu>
    </div>
    <div class="fr">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      companyList: [
        {
          id: 1,
          route: "/longzhichao",
          name: "龍之超地产",
        },
        {
          id: 2,
          route: "/tianfan",
          name: "天帆房产顾问",
        },
        {
          id: 3,
          route: "/tianteng",
          name: "天腾工业地产",
        },
        {
          id: 4,
          route: "/chaofangwang",
          name: "超房网",
        },
        {
          id: 5,
          route: "/hengshun",
          name: "亨顺拍卖行",
        },
        {
          id: 6,
          route: "/zhishang",
          name: "至上管家",
        },
        {
          id: 7,
          route: "/yinyu",
          name: "银宇按揭",
        },
      ],
      activeKey: 1,
    };
  },
  updated() {
    let list = this.companyList;
    let path = this.$route.path;
    let data = list.filter((item) => {
      return item.route == path;
    });
    this.activeKey = data[0].id;
  },
  mounted() {
    let list = this.companyList;
    let path = this.$route.path;
    let data = list.filter((item) => {
      return item.route == path;
    });
    this.activeKey = data[0].id;
  },
};
</script>

<style lang="less" >
.profile {
  width: 1000px;
  display: flex;
  min-height: 700px;
  margin: 0 auto;
}
.fl {
  width: 200px;
}
.ivu-menu.ivu-menu-light.ivu-menu-vertical {
  width: 100% !important;
}
.ivu-menu-item-group {
  width: 100%;
}
.ivu-menu-item-group ul {
  width: 100%;
}
.ivu-menu-vertical.ivu-menu-light:after {
  background-color: #fff;
}
.ivu-menu-item {
  width: 85%;
}
.ivu-menu {
  z-index: 0;
}
.fr {
  flex: 1;
  box-sizing: border-box;
}
.company-content {
  // background-color: #f7f5f4;
}
</style>
